import { connect } from 'react-redux'
import { hideNavigation } from 'redux/actions'
import NavigationOverlay from 'components/NavigationOverlay'

const mapStateToProps = state => ({
  isNavigationVisible: state.layout.isNavigationVisible
})

const mapDispatchToProps = dispatch => ({
  hideNavigation: () => dispatch(hideNavigation())
})

export default connect(mapStateToProps, mapDispatchToProps)(NavigationOverlay)
